import React from "react";
import {
  Dumbbell,
  Coffee,
  Calculator,
  Scale,
  Hotel,
  Wrench,
  Sparkles,
  Building2,
} from "lucide-react";
import { SectionHeader } from "@/sections/Services";

const INDUSTRIES = [
  { label: "Gyms & fitness businesses", icon: Dumbbell },
  { label: "Cafés & restaurants", icon: Coffee },
  { label: "Accountants", icon: Calculator },
  { label: "Law firms", icon: Scale },
  { label: "Hospitality", icon: Hotel },
  { label: "Local service businesses", icon: Wrench },
  { label: "Startups", icon: Sparkles },
  { label: "SMEs", icon: Building2 },
];

export default function Industries() {
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="relative py-24 md:py-32 border-t border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <SectionHeader
          eyebrow="Industries"
          title="Built for real businesses, not just tech demos"
          subtitle="We have worked with and supported businesses across practical, service-led industries — from gyms and cafés to accountants, law firms, hospitality operators and growing SMEs."
        />

        <div className="mt-14 flex flex-wrap gap-3 md:gap-4">
          {INDUSTRIES.map((industry, i) => {
            const Icon = industry.icon;
            return (
              <div
                key={industry.label}
                data-testid={`industry-chip-${i}`}
                className="mk-reveal group inline-flex items-center gap-2.5 rounded-full border border-white/10 bg-white/[0.04] px-5 py-3 text-sm text-slate-300 hover:text-white hover:bg-white/[0.08] hover:border-white/20 transition-all duration-300 cursor-default"
                style={{ transitionDelay: `${i * 40}ms` }}
              >
                <Icon className="h-4 w-4 text-[#00D4FF] transition-transform group-hover:scale-110" />
                {industry.label}
              </div>
            );
          })}
        </div>

        <div className="mt-16 mk-reveal grid grid-cols-2 md:grid-cols-4 gap-px rounded-2xl border border-white/10 bg-white/[0.02] overflow-hidden">
          <Stat value="6+" label="Years trading" />
          <Stat value="20+" label="SME sectors served" />
          <Stat value="UK" label="Based & registered" />
          <Stat value="∞" label="Product ventures ahead" />
        </div>
      </div>
    </section>
  );
}

function Stat({ value, label }) {
  return (
    <div className="bg-[#07111F] p-7 md:p-9">
      <div className="font-display text-3xl md:text-4xl text-white tracking-tight">
        {value}
      </div>
      <div className="mt-1.5 text-xs uppercase tracking-[0.2em] text-slate-500">
        {label}
      </div>
    </div>
  );
}
